import { apiGet, apiPatch } from './api';

export type MessageReportStatus = 'pending' | 'reviewed' | 'dismissed' | 'action_taken';

export type MessageReportItem = {
  _id: string;
  messageId?: {
    _id: string;
    contentPlain?: string;
    senderId?: string;
    threadId?: string;
  };
  threadId?: string;
  reporterId?: { _id: string; nickname?: string; email?: string };
  reason: string;
  details?: string;
  status: MessageReportStatus;
  hostContextType?: string;
  hostContextId?: string;
  createdAt: string;
};

type ListReportsResponse = {
  success: boolean;
  data?: {
    reports: MessageReportItem[];
    pagination: { page: number; limit: number; total: number; pages: number };
  };
};

type ResolveReportResponse = {
  success: boolean;
  message?: string;
  data?: { report: MessageReportItem };
};

export async function listMessageReports(params?: {
  page?: number;
  limit?: number;
  status?: MessageReportStatus | 'all';
}): Promise<ListReportsResponse> {
  const qs = new URLSearchParams();
  if (params?.page) qs.set('page', String(params.page));
  if (params?.limit) qs.set('limit', String(params.limit));
  if (params?.status) qs.set('status', params.status);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return apiGet(`/api/v1/admin/moderation/message-reports${suffix}`);
}

export async function resolveMessageReport(
  reportId: string,
  action: MessageReportStatus,
  hideMessage?: boolean,
): Promise<ResolveReportResponse> {
  return apiPatch(`/api/v1/admin/moderation/message-reports/${reportId}/resolve`, {
    action,
    hideMessage: !!hideMessage,
  });
}
